import type { Capabilities } from '@rtkwlf/rendall';
import { Outlet } from 'react-router-dom';

import { FeatureFlagGuard } from '@platform/client/feature-flags';
import type { FeatureConfig } from '@platform/client/features';

import { LegacyCapabilitiesGuard } from '@packages/components/capabilities/legacy-capabilities-guard';
import { hasAnyRequiredProperty } from '@packages/utils/has-any-required-property';

import i18n from './locales/i18n';

const incidentResponseCapability: Partial<Capabilities> = {
  canAccessIncidentResponse: true,
};

export default {
  routes: [
    {
      path: 'incident-response',
      element: (
        <FeatureFlagGuard featureFlag="INCIDENT_RESPONSE">
          <LegacyCapabilitiesGuard capabilities={incidentResponseCapability}>
            <Outlet />
          </LegacyCapabilitiesGuard>
        </FeatureFlagGuard>
      ),
      children: [
        {
          index: true,
          lazy: () => import('./pages/overview/overview.page'),
        },
      ],
    },
  ],
  navigation: ({ featureFlags, legacyCapabilities }) => {
    const hasIncidentResponseAccess =
      featureFlags?.INCIDENT_RESPONSE &&
      legacyCapabilities &&
      hasAnyRequiredProperty(incidentResponseCapability, legacyCapabilities);

    if (!hasIncidentResponseAccess) return {};

    return {
      incidentResponse: {
        irPlanner: {
          title: i18n.t('incidentResponse:title'),
          segment: '/incident-response',
        },
      },
    };
  },
} satisfies FeatureConfig;
